var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('mia-shared-page-header'),_c('div',{staticClass:"my-16 space-y-16"},[_c('mia-is-allowed',{attrs:{"to":"customer_portal_impersonation"}},[_c('mia-impersonate-panel')],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }